<template>
    <v-container grid-list-md fluid v-bind:class="padLRClass">
        <div v-bind:class="transparentClass">
        <div v-bind:class="backWhtClass">
            <h1 class="content-title">MembersList</h1> 

            <div class="MemberFilter mrgB25">

            <v-layout class="marB25">  


                <v-card v-bind:class="transparentClass" class="full-width">
                    <v-card-title class="headline light--cyan-bg" color="light-blue lighten-4" light v-bind:class="transparentPad0Class">

                        <v-layout hidden-sm-and-up class="marB-15 marT15" >
                            <v-flex sm12 class="marAuto clrBlue fntWht500">
                                <span class="float-left text-left padR10 padL30 fntInitial padL0" >NEW MEMBERS</span>
                                <span class="float-left text-left padLR10 fntInitial">BIRTHDAYS</span>
                                <span class="float-left text-left padLR10 fntInitial">MORE</span>
                            </v-flex>
                        </v-layout>

                        <v-layout row class="marB15">
                            <v-flex xs3 sm2 md2 lg2 d-flex>
                                <!-- <v-select label="ALL"> </v-select> -->
                            </v-flex>
                            <v-flex md6 lg6 hidden-xs-only sm6 class="marAuto clrBlue fntWht500">
                                <!-- <span class="float-left text-left padLR10 padL30 fntInitial">NEW MEMBERS</span>
                                <span class="float-left text-left padLR10 fntInitial">BIRTHDAYS</span>
                                <span class="float-left text-left padLR10 fntInitial">MORE</span> -->
                            </v-flex>
                            <v-flex xs4 sm2 md2 lg2 d-flex>
                                <v-select 
                                    :items="locationOptions"
                                    v-model="locationFilter"
                                    label="Location"
                                    class="MemberFilter__select"
                                    clearable  v-bind:class="custLSeltClass"
                                ></v-select> 
                            </v-flex>
                            <v-flex xs5 sm2 md2 lg2 d-flex> 
                                 <v-select 
                                    :items="sortOptions"
                                    v-model="sortFilter"
                                    label="Sort By"
                                    class="MemberFilter__select"
                                    clearable v-bind:class="fltRClass"
                                 ></v-select>
                            </v-flex>
                        </v-layout>
                      
                    </v-card-title>
                </v-card>
            </v-layout>

        </div>

            <!-- <div>
                <v-card v-bind:class="transparentClass">
                    <v-card-title class="headline light--cyan-bg" color="light-blue lighten-4" light v-bind:class="transparentPad0Class">
                        <v-layout row >
                            <v-flex xs3 sm2 md2 lg2 d-flex>
                                <v-select
                                :items="filterItems"
                                label="ALL" 
                                ></v-select>
                            </v-flex> 
                            <v-flex hidden-xs-only md6 lg6 sm6 class="marAuto clrBlue fntWht500">
                                <span class="float-left text-left padLR10 padL30 fntInitial">NEW MEMBERS</span>
                                <span class="float-left text-left padLR10 fntInitial">BIRTHDAYS</span>
                                <span class="float-left text-left padLR10 fntInitial">MORE</span>
                            </v-flex>
                            <v-flex xs4 sm2 md2 lg2 d-flex>
                                <v-select
                                :items="countryItems"
                                label="AUSTIN, TX" 
                                ></v-select>
                            </v-flex>
                            <v-flex xs5 sm2 md2 lg2 d-flex>
                                <v-select
                                :items="sortByItems"
                                label="SORT BY DATE">
                                </v-select>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                </v-card>
            </div> -->

            <div class="MemberList" v-if="isLoadingMembers == false">
                <v-layout wrap v-if="members.length > 0">
                    <v-flex lg3 md3 sm6 xs12 class="pad5" v-for="member in members" :key="member.id">
                        <member-item :member=member :memberId = "member.id" />
                    </v-flex>
                </v-layout>
                <v-flex v-else>
                    Nothing Found
                </v-flex>
            </div>
            <!-- <div v-else> -->
                 <v-layout row v-else>
                <v-flex class="text-xs-center">
                    <v-progress-circular :size="50" indeterminate color="default"></v-progress-circular>
                </v-flex>
            </v-layout>
            <!-- </div> -->
        </div>
        </div>
    </v-container>
</template>

<script>
    import UserService from "@/services/db/UserService.js";
    import MemberItem from "./member-item/member-item.vue";

    export default {
        name: "MembersList",
        components: {
          "member-item": MemberItem,
        },
        methods: {
            clearMembers() {
                this.members = [];
            },
            getTotalMembers() {
                UserService.getMembers({}).then( (members) => {
                    this.totalMembers = members.size;
                } )
                .catch(() => {
                });
            },
            getMembers() {
                this.isLoadingMembers = true;
                UserService.getMembers({
                    locations: this.locationFilter,
                    sortBy: this.sortFilter,
                    
                }).then( (members) => {
                    this.clearMembers();
                    this.isLoadingMembers = false;
                    members.forEach( doc => {
                        let member = doc.data();
                        member.id = doc.id;
                        this.members.push( member )
                    } ) 
                } )
                .catch(() => {
                });
            }
        },
        watch: {
            locationFilter: function() {
                this.getMembers();
            },
            sortFilter: function() {
                this.getMembers();
            },
        },
       computed: {
             padLRClass(){
                return { 
                "smPadLR0":this.$vuetify.breakpoint.smAndDown
                }
            },
              transparentClass(){
                return { 
                "bckTrans":this.$vuetify.breakpoint.smAndDown
                }
            },
              backWhtClass(){
                return { 
                "bckWhtAndPad1par":this.$vuetify.breakpoint.mdAndUp
                }
            },
            transparentPad0Class(){
                return { 
                "bckTransPad0":this.$vuetify.breakpoint.smAndDown
                }
            },
              custLSeltClass(){
                return { 
                "custLSelt":this.$vuetify.breakpoint.mdAndUp
                }
            },
              fltRClass(){
                return { 
                "custLSelt":this.$vuetify.breakpoint.mdAndUp
                }
            },
        },
        data() {
            return {
                members: [],
                totalMembers: "",
                isLoadingMembers: false,
                locationFilter: "",
                sortFilter: "",
                locationOptions: [
                    {
                        text: 'Austin, TX',
                        value: 'austin'
                    }, {
                        text: 'Chicago, IL',
                        value: 'chicago'
                    }
                ],
                sortOptions: [
                    {
                        text: 'Last Name',
                        value: 'lastName'
                    },{
                        text: 'City',
                        value: 'city'
                    },{
                        text: 'State',
                        value: 'state'
                    }
                ]
            }
        },
        created() {
            this.getTotalMembers();
            this.getMembers();
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .MemberFilter {
        display: flex;
        margin-bottom: 10px;
    }
    .MemberFilter__tabs {
        margin: 0; padding: 0;
        margin-right: auto;
        list-style: none;
    }
    .MemberFilter__tabs > li {
        margin-right: 5px;
        display: inline-block;
    }
    .MemberFilter__tabs > li > a {
        display: inline-block;
        padding: 16px;
        font: bold 12px 'Helvetica';
        color: #6483A7 !important;
        text-decoration: none;
        text-transform: uppercase;
    }
    .MemberFilter__tabs > li > a:hover,
    .MemberFilter__tabs > li > a.-active {
        border: 1px solid #D2DDE8;
        border-radius: 3px;
        background-color: #DFE9F1;
        padding: 15px;
    }
    .MemberFilter__selects {
        display: flex;
    }
    .MemberFilter__select {
        margin-left: 5px;
        width: 200px;
    }
    .MemberCard{
        border: 1px solid #E6F0F6;
        border-radius: 3px;
        
    }

    
.smPadLR0{
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.bckTrans{
    background: transparent !important;
    box-shadow: none;
}


.bckTransPad0{
    background: transparent !important;
    padding:0px !important; 
}

.bckWhtAndPad1par{
    background: #fff;
    padding: 1%;
}


.custLSelt{
    float: left; 
    margin-left: 2%;
}


</style>